// Meta Pixel helper - Pixel ID: 1011216287940548

const PIXEL_ID = '1011216287940548'

let initialized = false

export const initMetaPixel = () => {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  const w = window as any
  const d = document

  // Standard Meta Pixel base code (inlined and simplified)
  if (w.fbq) return
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  w.fbq = n
  if (!w._fbq) w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = d.createElement('script') as HTMLScriptElement
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = d.getElementsByTagName('script')[0]
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s)
  } else {
    d.head.appendChild(t)
  }

  // Init + single base PageView
  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')
}

export const trackPurchase = (value = 6.39, currency = 'USD') => {
  if (typeof window === 'undefined') return
  const w = window as any
  if (!w.fbq) return
  w.fbq('track', 'Purchase', { value, currency })
}

export const HOTMART_URL = 'https://pay.hotmart.com/K105790047V'

export const handleBuyClick = () => {
  setTimeout(() => {
    window.open(HOTMART_URL, '_blank', 'noopener,noreferrer')
  }, 200)
}
